import React, { useRef } from "react";
import { createPortal } from "react-dom";
import OutsideClickHandler from "react-outside-click-handler";

const MenuDropdown = ({
  isOpen,
  toggleDropdown,
  menuItems,
  menuIconSrc,
  menuClassName = "fixed z-[9999] w-[300px] bg-[#293043] py-2 rounded-3xl",
  itemClassName = "w-full text-left px-4 py-2 rounded-2xl transition-all duration-150 ease-linear hover:bg-[#363D50] border border-solid border-transparent active:border-[#FFD74A] text-[14px] font-medium text-white",
  dividerClassName = "w-full my-2 h-[1px] bg-[#434A5D]",
}) => {
  const buttonRef = useRef(null);

  const getPosition = () => {
    if (!buttonRef.current) return { top: 0, left: 0 };

    const rect = buttonRef.current.getBoundingClientRect();

    return {
      top: rect.bottom + window.scrollY,
      left: rect.right - 300 + window.scrollX,
    };
  };

  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <button
        ref={buttonRef}
        onClick={(e) => {
          e.stopPropagation();
          toggleDropdown();
        }}
        className="p-2"
      >
        <img src={menuIconSrc} alt="icon" />
      </button>

      {isOpen &&
        createPortal(
          <OutsideClickHandler onOutsideClick={toggleDropdown}>
            <div
              style={getPosition()}
              className={menuClassName}
            >
              {menuItems.map((item, index) => (
                <React.Fragment key={item.label}>
                  <div className="px-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown();
                        item.onClick();
                      }}
                      className={itemClassName}
                    >
                      {item.label}
                    </button>
                  </div>
                  {index < menuItems.length - 1 && (
                    <div className={dividerClassName} />
                  )}
                </React.Fragment>
              ))}
            </div>
          </OutsideClickHandler>,
          document.body
        )}
    </div>
  );
};

export default MenuDropdown;